export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";